import React from 'react';
import { connect } from 'react-redux';

import { getTranslate, getActiveLanguage } from 'react-localize-redux';

let CancelMispariWindow = ({translate, message, cancelMispari }) => {
  return(
    <div className="modal fade bd-cancelMispari-lg"  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title" >{translate('confirmation-message-title')}</h5>
            </div>
          </div>
          <div className="modal-body">
            <h6>{translate('confirmation-message')}</h6>
              {message}
          </div>
          <div className="form-group row">
            <div className="col text-right">
              <button className="btn btn-secondary" type="button" data-target=".bd-cancelMispari-lg"  data-toggle="modal" >{translate('cancel')}</button>
              <button className="btn btn-danger" type="button" onClick={() => cancelMispari()}  data-target=".bd-cancelMispari-lg"  data-toggle="modal"  >{translate('confirm')}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  }
}

CancelMispariWindow = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(CancelMispariWindow);
export default CancelMispariWindow;



// WEBPACK FOOTER //
// ./src/components/Mispari/CancelMispariWindow.js